import qs from 'query-string';
import {
  wechatLogin,
  getWeixinSign,
  IWechatConfigResponse,
  IWechatLoginResponse,
  IWechatLoginRequest,
} from '@/api/wechat';
import { getSearchPrams, getParameterValues } from './utils';

interface IUserInfo {
  email?: string;
  phone?: string;
  fullName?: string;
}

// 注入权限验证配置
export const setWeChatConfig = ({ appId, nonce, signature, timestamp }: IWechatConfigResponse) => {
  const { wx } = window;
  if (!wx) return;
  wx.config({
    debug: false,
    appId,
    timestamp,
    nonceStr: nonce,
    signature,
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'hideMenuItems'],
    openTagList: ['wx-open-launch-app'],
  });
};

// 分享
export const shareEvent = (shareData: IShareData) => {
  const { wx } = window;
  if (!wx) return;
  wx.ready(() => {
    // 分享
    wx.updateTimelineShareData(shareData);
    wx.updateAppMessageShareData(shareData);
  });
};
// 分享到朋友圈
export const shareUpdateTimeLineData = (shareData: IShareData) => {
  const { wx } = window;
  if (!wx) return;
  wx.ready(() => {
    wx.updateTimelineShareData(shareData);
  });
};
// 分享给朋友
export const shareUpdateAppMessageShareData = (shareData: IShareData) => {
  const { wx } = window;
  if (!wx) return;
  wx.ready(() => {
    wx.updateAppMessageShareData(shareData);
  });
};

// 同意授权，获取code, code会拼接在链接上
export const redirectUrl = (appid: string) => {
  const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
    window.location.href,
  )}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
  window.location.href = url;
};

const TOKEN_VERSION = '1';

export const setToken = (token: string) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('TOKEN_VERSION', TOKEN_VERSION);
};

interface AuthLoginParams {
  externalLogin?(params: IWechatLoginRequest): Promise<IWechatLoginResponse>;
  // 使用content token
  useContentToken?: boolean;
  // 额外参数
  externalLoginExtraParams?: {
    // WECHAT_PG 微信公众号， WECHAT_PG_APPLET 小程序
    oauthType?: string;
    groupBy?: boolean;
    isGroupUserNew?: boolean;
    freePhone?: string;
    loginType?: string;
    activityType?: string;
    leadId?: string;
    payload?: any;
  };
}

// 微信授权登录 -- access_token
export const authLogin = async (params: AuthLoginParams = {}) => {
  const paramsQuery = getSearchPrams();
  const authToken = localStorage.getItem('authToken');
  const userInfo = localStorage.getItem('cpUserInfo');
  const tokenVersion = localStorage.getItem('TOKEN_VERSION');
  const { refresh } = paramsQuery;
  const hasLoginInfo = authToken && userInfo && tokenVersion === TOKEN_VERSION && !refresh;
  const { href: url, search } = window.location;
  const weixinSign = await getWeixinSign(url);
  const { appId } = weixinSign;
  // 如果有登录信息并且当前 token 是已经成功登录了，直接返回 true
  // 加两个判断是因为兼容原来清除 token 的方式
  if (hasLoginInfo && window.sessionStorage.getItem('loginStatus')) {
    return true;
  }
  if (hasLoginInfo) {
    setWeChatConfig(weixinSign);
    window.sessionStorage.setItem('loginStatus', '1');
    return true;
  }
  const code = getParameterValues('wx');
  if (!code) {
    redirectUrl(appId);
    return false;
  }
  const res = await (params?.externalLogin || wechatLogin)({ code, ...params?.externalLoginExtraParams });
  if (res) {
    setWeChatConfig(weixinSign);
    localStorage.setItem('cpUserInfo', JSON.stringify(res));
    localStorage.setItem('TOKEN_VERSION', TOKEN_VERSION);
    if (params?.useContentToken) {
      setToken(res?.content?.token || '');
    } else {
      setToken(res.token);
    }
  }
  return res;
};

// 判断是否在微信环境
export const isWechatEnvironment = () => {
  const ua = window.navigator.userAgent;
  const data = ua.match(/MicroMessenger/i) || [];
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (data[0] === 'MicroMessenger') {
    return true;
  }
  return false;
};

// 是否是微信小程序环境 不区分大小写
export const isMiniProgram = () => {
  const userAgent = navigator.userAgent;
  if (/micromessenger/i.test(userAgent) && /miniprogram/i.test(userAgent)) {
    // 是在小程序中打开
    return true;
  } else {
    // 不是在小程序中打开
    return false;
  }
};
